"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8651],{

/***/ 98651:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ VideoBlock_VideoBlock; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/axios/index.js + 40 modules
var axios = __webpack_require__(50196);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./components/TinaAsset/index.ts
var TinaAsset = __webpack_require__(48642);
// EXTERNAL MODULE: ./theme/mixins/padding.ts
var padding = __webpack_require__(54986);
// EXTERNAL MODULE: ./components/TinaVideo/index.tsx
var TinaVideo = __webpack_require__(57722);
;// CONCATENATED MODULE: ./blocks/VideoBlock/VideoBlock.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: auto;\n    ",
        ";\n  "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  margin: 0 3px;\n\n  ",
        ";\n\n  background: ",
        ";\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      background: ",
        ";\n      padding: ",
        "rem ",
        "rem;\n      border-radius: 1.5rem;\n    "
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  border-radius: 1rem;\n  ",
        "\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: initial;\n  "
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: none;\n  "
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: none;\n  "
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: ",
        ";\n  svg {\n    border-radius: 16px;\n  }\n  ",
        "\n"
    ]);
    _templateObject9 = function() {
        return data;
    };
    return data;
}








const Lottie = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(296), __webpack_require__.e(9260)]).then(__webpack_require__.t.bind(__webpack_require__, 69260, 23)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(69260)
            ]
    },
    ssr: false
});
const Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fe6b8235-0"
})(_templateObject1(), (0,padding/* blockPadV */.zr)(), (param)=>{
    let { theme  } = param;
    return theme.mq.md(_templateObject(), (0,padding/* blockPadH */.XA)());
}, (param)=>{
    let { theme  } = param;
    return theme.themeColors.bg;
});
const Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fe6b8235-1"
})(_templateObject3(), (0,padding/* blockW */.g5)(), (param)=>{
    let { theme , backgroundVideoColor , topbotPadding , sidePadding  } = param;
    return (topbotPadding || sidePadding) && theme.mq.md(_templateObject2(), backgroundVideoColor || "transparent", topbotPadding, sidePadding);
});
const VideoWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fe6b8235-2"
})(_templateObject5(), (param)=>{
    let { hasMobileImage , hasMobileLottie  } = param;
    return hasMobileImage || hasMobileLottie ? "none" : "initial";
}, (param)=>{
    let { theme  } = param;
    return theme.mq.md(_templateObject4());
});
const ImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fe6b8235-3"
})(_templateObject7(), (param)=>{
    let { hasMobileImage  } = param;
    return hasMobileImage ? "initial" : "none";
}, (param)=>{
    let { theme  } = param;
    return theme.mq.md(_templateObject6());
});
const LottieWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fe6b8235-4"
})(_templateObject9(), (param)=>{
    let { hasMobileLottie  } = param;
    return hasMobileLottie ? "initial" : "none";
}, (param)=>{
    let { theme  } = param;
    return theme.mq.md(_templateObject8());
});
const VideoBlock = (param)=>{
    let { backgroundVideoColor , videoMeta , hasMobieImage , mobileImage , topbotPadding , sidePadding , hasMobileLottie , lottieFp  } = param;
    const [lottie, setLottie] = (0,react.useState)();
    const fetchLottie = async ()=>{
        if (lottieFp) {
            const res = await axios/* default.get */.ZP.get(lottieFp);
            if ((res === null || res === void 0 ? void 0 : res.status) === 200) setLottie(res === null || res === void 0 ? void 0 : res.data);
        }
    };
    (0,react.useEffect)(()=>{
        fetchLottie();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
            topbotPadding: topbotPadding || 0,
            sidePadding: sidePadding || 0,
            backgroundVideoColor: backgroundVideoColor || "",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(LottieWrapper, {
                    hasMobileLottie: !!hasMobileLottie,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Lottie, {
                        animationData: lottie,
                        loop: true
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWrapper, {
                    hasMobileImage: !!hasMobieImage,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TinaAsset/* default */.Z, {
                        asset: mobileImage
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoWrapper, {
                    hasMobileImage: !!hasMobieImage,
                    hasMobileLottie: !!hasMobileLottie,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TinaVideo/* default */.Z, {
                        src: videoMeta === null || videoMeta === void 0 ? void 0 : videoMeta.url,
                        ...videoMeta
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var VideoBlock_VideoBlock = (VideoBlock);

;// CONCATENATED MODULE: ./blocks/VideoBlock/index.ts



/***/ }),

/***/ 3185:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ GfxImage_GfxImage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/GfxImage/GfxImage.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}



const GfxImage = (param)=>{
    let { layout , quality , src , width =0 , height =0 , objectFit , blurDataURL , placeholder ="empty" , alt , ...rest } = param;
    if (!src) {
        return null;
    }
    const isLayoutFill = layout === "fill";
    const isSvg = src.includes(".svg");
    const imageProps = {
        layout,
        ...rest,
        ...isSvg && {
            unoptimized: true
        },
        ...placeholder === "blur" && {
            blurDataURL: blurDataURL
        },
        ...objectFit !== "none" && {
            style: {
                objectFit
            }
        },
        ...!isLayoutFill && {
            width: width,
            height: height
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
        src: src,
        placeholder: placeholder,
        alt: alt,
        quality: quality,
        ...imageProps
    });
};
/* harmony default export */ var GfxImage_GfxImage = ((0,styled_components_browser_esm/* default */.ZP)(GfxImage).withConfig({
    componentId: "sc-2250b3a7-0"
})(_templateObject()));

;// CONCATENATED MODULE: ./components/GfxImage/index.ts



/***/ }),

/***/ 54995:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14141);
/* harmony import */ var components_GfxImage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3185);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    max-height: 100vh;\n    flex: 0; \n    margin: 0 auto;\n  "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    padding: 0;\n  "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        border-radius: ",
        "px;\n      "
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n      ",
        "\n    "
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  height: 100%;\n  padding: ",
        ";\n  ",
        "\n  ",
        "\n  /* desktop only need >= 0, cause if not we would simply take the border radius from mobile.\nMobile doesn't need it, since if you set mobile to 0, it reads as false and doesnt add border-radius */\n  ",
        "\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}




const Image = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(components_GfxImage__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-da1c7ae5-0"
})(_templateObject4(), (param)=>{
    let { $horizontalPaddingMobile  } = param;
    return $horizontalPaddingMobile && "0 1.5rem";
}, (param)=>{
    let { theme , $maxHeightMobile  } = param;
    return $maxHeightMobile && theme.mq.ltLg(_templateObject());
}, (param)=>{
    let { theme  } = param;
    return theme.mq.md(_templateObject1());
}, (param)=>{
    let { theme: { mq  } , mobileborderradius , desktopborderradius  } = param;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject3(), "border-radius: ".concat(mobileborderradius ? mobileborderradius : 16, "px;"), mq.md(_templateObject2(), desktopborderradius ? desktopborderradius : 24));
});
const TinaAsset = (param)=>{
    let { asset , className , ...props } = param;
    // do not render anything if no URL is provided
    if (!asset || !(asset === null || asset === void 0 ? void 0 : asset.src)) {
        return null;
    }
    // We don't want to apply either attribute if both conditions are not met
    const imageBlur = (asset === null || asset === void 0 ? void 0 : asset.placeholder) === "blur" && (asset === null || asset === void 0 ? void 0 : asset.blurDataURL) && {
        placeholder: asset === null || asset === void 0 ? void 0 : asset.placeholder,
        blurDataURL: asset === null || asset === void 0 ? void 0 : asset.blurDataURL
    };
    const imageProps = {
        ...props,
        ...imageBlur
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Image, {
        ...imageProps,
        alt: (asset === null || asset === void 0 ? void 0 : asset.alt) || "image description",
        src: (asset === null || asset === void 0 ? void 0 : asset.src) || "",
        priority: Boolean(asset === null || asset === void 0 ? void 0 : asset.priority),
        quality: (asset === null || asset === void 0 ? void 0 : asset.quality) || 75,
        objectFit: (asset === null || asset === void 0 ? void 0 : asset.objectFit) || "none",
        className: className,
        $horizontalPaddingMobile: (asset === null || asset === void 0 ? void 0 : asset.horizontalPadding) ? true : undefined,
        $maxHeightMobile: (asset === null || asset === void 0 ? void 0 : asset.maxHeightMobile) ? asset === null || asset === void 0 ? void 0 : asset.maxHeightMobile : undefined,
        width: (asset === null || asset === void 0 ? void 0 : asset.width) || 0,
        height: (asset === null || asset === void 0 ? void 0 : asset.height) || 0
    });
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(TinaAsset).withConfig({
    componentId: "sc-da1c7ae5-1"
})(_templateObject5()));


/***/ }),

/***/ 48642:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _TinaAsset__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _TinaAsset__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54995);



/***/ }),

/***/ 4262:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TinaVideo_TinaVideo; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./public/asset_list.json
var asset_list_namespaceObject = JSON.parse('{"K":{"/uploads/cgr-timeline-2.mp4":{"name":"cgr-timeline-2.mp4"},"/uploads/cgr_scroll.mp4":{"name":"cgr_scroll.mp4"},"/uploads/figo-blog.mp4":{"name":"figo-blog.mp4"},"/uploads/figo-cover-compressed.mp4":{"name":"figo-cover-compressed.mp4"},"/uploads/figo-ipad.mp4":{"name":"figo-ipad.mp4"},"/uploads/goodfriend-booking-compressed.mp4":{"name":"goodfriend-booking-compressed.mp4"},"/uploads/goodfriend-calendar-compressed.mp4":{"name":"goodfriend-calendar-compressed.mp4"},"/uploads/goodfriend-map-animation-compressed.mp4":{"name":"goodfriend-map-animation-compressed.mp4"},"/uploads/goodfriend-search-compressed.mp4":{"name":"goodfriend-search-compressed.mp4"},"/uploads/goodfriend-ui-compressed.mp4":{"name":"goodfriend-ui-compressed.mp4"},"/uploads/new_cgr_scroll.mp4":{"name":"new_cgr_scroll.mp4"},"/uploads/overview.mp4":{"name":"overview.mp4"},"/uploads/overview_final.mp4":{"name":"overview_final.mp4"},"/uploads/plume-cover-compressed.mp4":{"name":"plume-cover-compressed.mp4"},"/uploads/plume-laptop-animation-compressed.mp4":{"name":"plume-laptop-animation-compressed.mp4"},"/uploads/plume-page-load-compressed.mp4":{"name":"plume-page-load-compressed.mp4"},"/uploads/plume-shop-compressed.mp4":{"name":"plume-shop-compressed.mp4"}}}');
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
;// CONCATENATED MODULE: ./components/TinaVideo/TinaVideo.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 0;\n  "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n        border-radius: ",
        "px;\n      "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      ",
        "\n      ",
        "\n    "
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  padding: ",
        ";\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}




/* desktop only need >= 0, cause if not we would simply take the border radius from mobile.
Mobile doesn't need it, since if you set mobile to 0, it reads as false and doesnt add border-radius */ const Video = styled_components_browser_esm/* default.video.withConfig */.ZP.video.withConfig({
    componentId: "sc-204519d6-0"
})(_templateObject3(), (param)=>{
    let { $horizontalPaddingMobile  } = param;
    return $horizontalPaddingMobile && "0 1.5rem";
}, (param)=>{
    let { theme  } = param;
    return theme.mq.md(_templateObject());
}, (param)=>{
    let { theme: { mq  } , mobileborderradius , desktopborderradius  } = param;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject2(), "border-radius: ".concat(mobileborderradius || 16, "px;"), mq.md(_templateObject1(), desktopborderradius || 24));
});
const TinaVideo = (param)=>{
    let { src , poster , ...props } = param;
    if (!src) {
        return null;
    }
    // @ts-ignore
    const meta = asset_list_namespaceObject.K[src];
    if (!meta) {
        console.log("run asset meta generator");
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Video, {
        autoPlay: true,
        loop: true,
        playsInline: true,
        muted: true,
        width: meta.width,
        height: meta.height,
        poster: (poster === null || poster === void 0 ? void 0 : poster.src) || undefined,
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
            src: src
        })
    });
};
/* harmony default export */ var TinaVideo_TinaVideo = (TinaVideo);


/***/ }),

/***/ 57722:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _TinaVideo__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _TinaVideo__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4262);



/***/ })

}]);